const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

export const placesClient = {
  async searchHotels(provinceFilter, maxResultCount = 5) {
    const res = await fetch(`${API_BASE}/places/search-text`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        textQuery: "otel hotel",
        provinceFilter,
        languageCode: "tr",
        maxResultCount,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Arama hatası");
    return data.places || [];
  },

  async searchRestaurants(provinceFilter, maxResultCount = 5) {
    const res = await fetch(`${API_BASE}/places/search-text`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        textQuery: "restoran restaurant",
        provinceFilter,
        languageCode: "tr",
        maxResultCount,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Arama hatası");
    return data.places || [];
  },

  async searchByQuery(textQuery, provinceFilter, maxResultCount = 10) {
    const res = await fetch(`${API_BASE}/places/search-text`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        textQuery,
        provinceFilter,
        languageCode: "tr",
        maxResultCount,
      }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Arama hatası");
    return data.places || [];
  },

  async getDetails(placeId) {
    const res = await fetch(`${API_BASE}/places/details/${encodeURIComponent(placeId)}?languageCode=tr`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.message || "Detay hatası");
    return data.place || null;
  },
};
